(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationDiagnosis', EvaluationDiagnosis);

    EvaluationDiagnosis.$inject = ['$resource'];

    function EvaluationDiagnosis ($resource) {
        var resourceUrl =  'api/evaluation-diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-diagnoses/by-evaluation/:id', isArray: true },
            'reorder': { method: 'POST', url: 'api/evaluation-diagnoses/reorder', isArray: false }
        });
    }
})();
